import { Outlet } from 'react-router-dom'

const PublicLayout = () => {
    return (
        <div className="w-full h-screen bg-gray-700">
            <Outlet />
        </div>
    )
}

export default PublicLayout
